import { Container, ModalHeader, Content } from './styles';
import CancelRegisterContent from './Content';
import { CloseButton, Modal } from '@starsoft/common/components';
import { useModal } from '@/hooks/modals/useModal';
import { ModalsKey } from '@/enums/modalsKey';
import { useUserAccount } from '@/api/user/queries';

export default function CancelRegisterModal() {
  const { handleContainer, isOpen, onClose } = useModal(
    ModalsKey.CancelRegister,
  );
  const { isAuthorized } = useUserAccount();

  return (
    <Modal open={isOpen && !isAuthorized} onClose={onClose}>
      <Container onClick={handleContainer}>
        <ModalHeader>
          <div />
          <CloseButton onClick={() => onClose()} />
        </ModalHeader>
        <Content>
          <CancelRegisterContent />
        </Content>
      </Container>
    </Modal>
  );
}
